<template>
  <div class="w-full bg-slate-50 min-h-screen p-6" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-5xl mx-auto">
      
      <!-- HEADER -->
      <div class="mb-6 flex items-center justify-between">
        <div>
          <button @click="$router.back()" class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-colors mb-2">
            <v-icon small color="inherit">mdi-arrow-left</v-icon>
            <span class="text-[10px] font-bold uppercase tracking-wider">Voltar</span>
          </button>
          <h1 class="text-2xl font-bold text-slate-700">{{ id ? 'Editar Veículo' : 'Cadastrar Veículo' }}</h1>
        </div>
      </div>

      <div class="space-y-6">
        <!-- CARD 1: IDENTIFICAÇÃO E VÍNCULO -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-file-document-edit</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">IDENTIFICAÇÃO E VÍNCULO</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- Prefeitura -->
              <div class="md:col-span-12">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Prefeitura</label>
                <select
                  v-model="data.prefecture_id"
                  @change="selectSecretariats(data.prefecture_id)"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a Prefeitura...</option>
                  <option v-for="item in prefectures" :key="item.prefecture_id" :value="item.prefecture_id">
                    {{ item.prefecture_social_name }}
                  </option>
                </select>
              </div>

              <!-- Secretaria -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Secretaria</label>
                <select
                  v-model="data.sec_id"
                  @change="selectSubSectors(data.sec_id)"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a Secretaria...</option>
                  <option v-for="item in secretariats" :key="item.sec_id" :value="item.sec_id">
                    {{ item.sec_name }}
                  </option>
                </select>
              </div>

              <!-- Subsetor -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Subsetor</label>
                <select
                  v-model="data.subsec_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione o Subsetor...</option>
                  <option v-for="item in subsectors" :key="item.subsec_id" :value="item.subsec_id">
                    {{ item.subsec_desc }}
                  </option>
                </select>
              </div>

              <!-- Placa -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Placa</label>
                <input 
                  type="text" 
                  v-model="data.vehicle_board" 
                  placeholder="Ex: ABC-1234"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase"
                >
              </div>

              <!-- Renavam -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Número do Renavam</label>
                <input 
                  type="text" 
                  v-model="data.vehicle_renavan" 
                  placeholder="00000000000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Código da Unidade Gestora -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Unidade Gestora</label>
                <input 
                  type="text" 
                  v-model="data.vehicle_cod" 
                  placeholder="000000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Codigo Próprio da Unidade -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Cod. Maquina</label>
                <input 
                  type="text" 
                  v-model="data.vehicle_cod_maquina" 
                  placeholder="000000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Marca -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Marca</label>
                <select
                  v-model="data.brand_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a Marca...</option>
                  <option v-for="item in brands" :key="item.brand_id" :value="item.brand_id">
                    {{ getBrandText(item) }}
                  </option>
                </select>
              </div>
              
              <!-- Vínculo -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Vínculo</label>
                <select v-model="data.bond_id" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in bonds" :key="item.bond_id" :value="item.bond_id">{{ item.bond_desc }}</option>
                </select>
              </div>

              <!-- Atendimento -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Atendimento</label>
                <select v-model="data.attendance_id" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in attendances" :key="item.attendance_id" :value="item.attendance_id">{{ item.attendance_desc }}</option>
                </select>
              </div>

              <!-- Proprietário -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Proprietário</label>
                <select v-model="data.vehicle_proprietario" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in proprietario" :key="item.proprietario_id" :value="item.proprietario_id">{{ item.proprietario_nome }}</option>
                </select>
              </div>

              <!-- Locador -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Locador</label>
                <select v-model="data.vehicle_locador" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in locador" :key="item.locador_id" :value="item.locador_id">{{ item.locador_nome }}</option>
                </select>
              </div>

              <!-- Categoria -->
              <div class="md:col-span-12">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Categoria</label>
                <select v-model="data.vehicle_categoria" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <option :value="null" disabled>Selecione...</option>
                  <option :value="1">Veículo</option>
                  <option :value="2">Máquina</option>
                </select>
              </div>
            </div>
          </div>
        </section>

        <!-- CARD 2: ESPECIFICAÇÕES E CONSUMO -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #313131;">
            <v-icon color="orange" small>mdi-engine-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ESPECIFICAÇÕES E CONSUMO</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- Ano Fab -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Ano Fab.</label>
                <input 
                  type="text" 
                  v-mask="'####'"
                  v-model="data.vehicle_manufacturing_year" 
                  placeholder="2022"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Ano Modelo -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Ano Modelo</label>
                <input 
                  type="text" 
                  v-mask="'####'"
                  v-model="data.vehicle_model_year" 
                  placeholder="2023"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Modelo -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Modelo</label>
                <select
                  v-model="data.model_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione o Modelo...</option>
                  <option v-for="item in models" :key="item.model_id" :value="item.model_id">
                    {{ getModelText(item) }}
                  </option>
                </select>
              </div>

              <!-- Cor -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Cor</label>
                <select
                  v-model="data.color_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a Cor...</option>
                  <option v-for="item in colors" :key="item.color_id" :value="item.color_id">
                    {{ item.color_desc }}
                  </option>
                </select>
              </div>

              <!-- Combustível -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Combustível</label>
                <select
                  v-model="data.fuel_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in fuels" :key="item.fuel_id" :value="item.fuel_id">
                    {{ item.fuel_desc }}
                  </option>
                </select>
              </div>

              <!-- Tipo de Consumo -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Consumo</label>
                <select
                  v-model="data.consumption_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione...</option>
                  <option v-for="item in consumption" :key="item.consumption_id" :value="item.consumption_id">
                    {{ item.consumption_desc }}
                  </option>
                </select>
              </div>

              <!-- Tanque -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Tanque (L)</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_tank_capacity" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>
              
              <!-- Consumo Mínimo -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Consumo Mín. (Km/L)</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_average_consumption_minimum" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Consumo Máximo -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Consumo Máx. (Km/L)</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_average_consumption_maximum" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Limite Litros -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Limite (Litros)</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_consumption_liters_maximum" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Consumo Hora -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Consumo Hora</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_consumption_liters_hour" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Valor -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Valor Atual</label>
                <input 
                  type="text" 
                  v-mask-decimal.br="2"
                  v-model="data.vehicle_current_value" 
                  placeholder="0,00"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>
              
              <!-- Datas -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Aquisição</label>
                <input type="text" v-mask-date.br v-model="data.vehicle_date_acquisition" placeholder="DD/MM/AAAA" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Encerramento</label>
                <input type="text" v-mask-date.br v-model="data.vehicle_date_closure" placeholder="DD/MM/AAAA" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Últ. Reg. TCE</label>
                <input type="text" v-mask-date.br v-model="data.vehicle_date_last_tce_record" placeholder="DD/MM/AAAA" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>
            </div>
          </div>
        </section>

        <!-- CARD 3: PARÂMETROS E OBSERVAÇÕES -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #313131;">
            <v-icon color="orange" small>mdi-tune-variant</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">PARÂMETROS E OBSERVAÇÕES</h2>
          </div>
          
          <div class="p-8">
             <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <!-- Parâmetros -->
                <div>
                  <div class="flex items-center gap-2 mb-4">
                    <h3 class="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center md:text-left">Parâmetros do Veículo</h3>
                  </div>
                  <div class="grid grid-cols-2 gap-3">
                    <div v-for="param in [
                      { key: 'vehicle_reports', label: 'Relatórios' },
                      { key: 'vehicle_hodometro', label: 'Hodômetro' },
                      { key: 'vehicle_active', label: 'Veículo Ativo' },
                      { key: 'abastecimento_extra', label: 'Abastec. Extra' },
                      { key: 'abastecimento_autorizacao', label: 'Abastec. Autorização' },
                      { key: 'vehicle_horimetro', label: 'Horímetro' }
                    ]" :key="param.key"
                    :class="['p-3 rounded-lg border flex items-center gap-3 transition-all cursor-pointer select-none', data[param.key] ? 'bg-orange-50 border-orange-200 shadow-sm' : 'bg-slate-50/50 border-slate-100 hover:border-slate-200']"
                    @click="data[param.key] = !data[param.key]">
                      <div :class="['w-5 h-5 rounded flex items-center justify-center border transition-colors', data[param.key] ? 'bg-orange-500 border-orange-500' : 'bg-white border-slate-300']">
                        <v-icon v-if="data[param.key]" x-small color="white">mdi-check</v-icon>
                      </div>
                      <span :class="['text-[10px] font-bold uppercase tracking-tight', data[param.key] ? 'text-orange-700' : 'text-slate-500']">{{ param.label }}</span>
                    </div>
                  </div>
                </div>

                <!-- Observações -->
                <div>
                  <div class="flex items-center gap-2 mb-4">
                    <h3 class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Observações Adicionais</h3>
                  </div>
                  <textarea
                    v-model="data.vehicle_observations"
                    placeholder="Notas importantes sobre este veículo..."
                    class="w-full h-[140px] bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-all resize-none"
                  ></textarea>
                </div>
             </div>
          </div>

          <!-- FOOTER DENTRO DO CARD FINAL (PADRÃO DO SISTEMA) -->
          <div class="bg-slate-50 px-8 py-5 border-t border-slate-200 flex justify-end items-center gap-4">
            <button 
              @click="$router.back()"
              class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
            >
              Cancelar
            </button>
            <div class="flex-none">
              <button
                @click="validate"
                :disabled="loader"
                class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
              >
                <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    secretariats: [],
    subsectors: [],
    brands: [],
    models: [],
    colors: [],
    fuels: [],
    consumption: [],
    billings: ["POR VEICULO", "POR SECRETARIA"],
    bonds: [],
    attendances: [],
    proprietario: [],
    locador: [],
    snack: { show: false, message: "", color: "success" },
    data: {
      vehicle_id: null,
      prefecture_id: null,
      sec_id: null,
      subsec_id: null,
      model_id: null,
      brand_id: null,
      color_id: null,
      fuel_id: null,
      consumption_id: null,
      bond_id: null,
      billing_type: "",
      attendance_id: null,
      vehicle_board: null,
      vehicle_manufacturing_year: null,
      vehicle_model_year: null,
      vehicle_tank_capacity: 0.0,
      vehicle_average_consumption_minimum: 0.0,
      vehicle_average_consumption_maximum: 0.0,
      vehicle_consumption_liters_maximum: 0.0,
      vehicle_consumption_liters_hour: 0.0,
      vehicle_number_of_liters: 0.0,
      vehicle_amount_value: 0.0,
      vehicle_date_acquisition: null,
      vehicle_date_closure: null,
      vehicle_date_last_tce_record: null,
      vehicle_last_kmh: 0.0,
      vehicle_current_value: 0.0,
      vehicle_observations: null,
      vehicle_reports: null,
      vehicle_hodometro: null,
      vehicle_horimetro: null,
      vehicle_active: null,
      vehicle_renavan: "",
      vehicle_proprietario: null,
      vehicle_locador: null,
      vehicle_cod: null,
      vehicle_cod_maquina: null,
      vehicle_categoria: null,
      abastecimento_autorizacao: false,
      abastecimento_extra: false,
    },
    prefecture_id: null,
  }),
  created() {
    this.$http.get("prefectures").then((r) => (this.prefectures = r.data));
    this.$http.get("proprietario").then((r) => (this.proprietario = r.data));
    this.$http.get("locador").then((r) => (this.locador = r.data));
    this.$http.get("/vehicles/brands").then((r) => (this.brands = r.data.filter((i) => i.brand_num !== null && i.brand_num !== "")));
    this.$http.get("/vehicles/models").then((r) => (this.models = r.data.filter((i) => i.model_num !== null && i.model_num !== "")));
    this.$http.get("/vehicles/colors").then((r) => (this.colors = r.data));
    this.$http.get("/settings/fuels").then((r) => (this.fuels = r.data));
    this.$http.get("/settings/bonds").then((r) => (this.bonds = r.data));
    this.$http.get("/settings/consumption").then((r) => (this.consumption = r.data));
    this.$http.get("/settings/attendance_types").then((r) => (this.attendances = r.data));

    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/vehicles/${this.id}`).then((r) => {
        this.prefecture_id = r.data[0].prefecture_id;
        this.data = r.data[0];
        
        const decimalFields = [
          'vehicle_average_consumption_maximum',
          'vehicle_average_consumption_minimum',
          'vehicle_consumption_liters_hour',
          'vehicle_consumption_liters_maximum',
          'vehicle_tank_capacity',
          'vehicle_current_value',
          'vehicle_amount_value',
          'vehicle_number_of_liters'
        ];
        
        decimalFields.forEach(field => {
          if (r.data[0][field] !== null && r.data[0][field] !== undefined) {
             r.data[0][field] = Number(r.data[0][field]).toFixed(2);
          }
        });

        this.data.vehicle_date_acquisition = this.data.vehicle_date_acquisition && this.convertDate(r.data[0].vehicle_date_acquisition);
        this.data.vehicle_date_closure = this.data.vehicle_date_closure && this.convertDate(r.data[0].vehicle_date_closure);
        this.data.vehicle_date_last_tce_record = this.data.vehicle_date_last_tce_record && this.convertDate(r.data[0].vehicle_date_last_tce_record);

        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
        this.selectSecretariats(this.data.prefecture_id);
        this.selectSubSectors(this.data.sec_id);
      });
    }
  },
  methods: {
    validate() {
      // Basic manual validation for required fields
      if (!this.data.prefecture_id || !this.data.sec_id) {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção: Preencha os campos obrigatórios!";
        return;
      }
      this.createOrUpdate();
    },
    selectSecretariats(id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/prefectures/secretariats/${id}`).then((r) => {
        this.secretariats = r.data;
        this.$store.dispatch("setLoader", false);
      });
    },
    selectSubSectors(id) {
      this.$http.get(`/prefectures/subsectors/${id}`).then((r) => {
        this.subsectors = r.data;
      });
    },
    convertDate(v) {
      if (v) {
        v = v.replace("-", "").replace("-", "");
        let year = v.substring(0, 4);
        let month = v.substring(4, 6);
        let day = v.substring(6, 8);
        return `${day}/${month}/${year}`;
      }
      return false;
    },
    createOrUpdate() {
      this.loader = true;
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/vehicles/${this.id}` : '/vehicles';
      
      this.$store.dispatch("setLoader", this.loader);
      this.$http[method](url, this.data)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result || "Sucesso!";
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
          setTimeout(() => {
            this.$router.push(this.id ? `/vehicles-manager/${this.prefecture_id}` : "/vehicles-manager");
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    getModelText(item) {
      return `${item.model_desc} - ${item.model_num}`;
    },
    getBrandText(item) {
      return `${item.brand_desc} - ${item.brand_num}`;
    },
  },
};
</script>

<style scoped>
/* Optional specific overrides */
</style>
